// DESTINATION FORMS
export const AddDestinationSchema = {
  type: "object",
  properties: {
    name: {
      type: "string",
      title: "Name",
      minLength: 3,
      description: "Please enter destination name",
    },
    type: {
      type: "string",
      title: "Type",
      enum: [
        { name: "Day Hike", id: "1" },
        { name: "Over Night", id: "2" },
        { name: "Mountaineering", id: "3" },
      ],
    },
    duration: {
      type: "number",
      title: "Duration",
      description: "Please enter duration",
    },

    durationUnits: {
      type: "string",
      title: "Duration Type",
      enum: [
        { name: "Hours", id: "hours" },
        { name: "Days", id: "days" },
      ],
    },

    maxElevation: {
      type: "number",
      title: "Max Elevation",
      description: "Please enter max elevation",
    },

    elevationGain: {
      type: "number",
      title: "Elevation Gain",
      description: "Please enter elevation gain",
    },
    distanceInKm: {
      type: "number",
      title: "Distance (Km)",
      description: "Please enter distance (km)",
    },
    country: {
      type: "string",
      title: "Country",
      enum: [
        { name: "Day Hike", id: "1" },
        { name: "Over Night", id: "2" },
        { name: "Mountaineering", id: "3" },
      ],
    },
    location: {
      type: "string",
      title: "Location",
      minLength: 3,
      description: "Please enter location name",
    },

    difficulty: {
      type: "string",
      title: "Difficulty",
      enum: [
        { name: "Day Hike", id: "1" },
        { name: "Over Night", id: "2" },
        { name: "Mountaineering", id: "3" },
      ],
    },

    description: {
      type: "string",
      title: "Description",
      description: "Destination description",
    },
    isChildFriendly: {
      type: "boolean",
      title: "Is Child Friendly?",
    },
    isTraverse: {
      type: "boolean",
      title: "Is Traverse?",
    },
    destinationIds: {
      type: "array",
      format: "select",
      title: "Destination in traverse",
      enum: [
        { name: "Day Hike", id: "1" },
        { name: "Over Night", id: "2" },
        { name: "Mountaineering", id: "3" },
      ],
    },

    latitude: {
      type: "string",
      title: "Latitude",
      minLength: 3,
      description: "Please enter latitude",
    },

    longitude: {
      type: "string",
      title: "Longitude",
      minLength: 3,
      description: "Please enter longitude",
    },
  },
  required: [],
};

export const AddDestinationUiSchema = (countries, destinationOptions) => {
  
  return {
    type: "VerticalLayout",
    elements: [
      {
        type: "Control",
        scope: "#/properties/name",
        label: "Name",
        required: true,
      },
      {
        type: "Control",
        scope: "#/properties/type",
        label: "Type",
        options: [
          { name: "Day Hike", id: "1" },
          { name: "Over Night", id: "2" },
          { name: "Mountaineering", id: "3" },
        ],
        required: true,
      },

      {
        type: "HorizontalLayout",
        elements: [
          {
            type: "Control",
            scope: "#/properties/duration",
            label: "Duration",
            required: true,
          },

          {
            type: "Control",
            scope: "#/properties/durationUnits",
            label: "Duration Units",
            options: [
              { name: "Hours", id: "hours" },
              { name: "Days", id: "days" },
            ],
            required: true,
          },
        ],
      },
      {
        type: "HorizontalLayout",
        elements: [
          {
            type: "Control",
            scope: "#/properties/distanceInKm",
            label: "Distance (Km)",
            required: true,
          },

          {
            type: "Control",
            scope: "#/properties/difficulty",
            label: "Difficulty",
            options: [
              { name: "Begginer Friendly", id: "1" },
              { name: "Moderate", id: "2" },
              { name: "Challenging", id: "3" },
              { name: "Very hard", id: "4" },
            ],
            required: true,
          },
        ],
      },

      {
        type: "HorizontalLayout",
        elements: [
          {
            type: "Control",
            scope: "#/properties/maxElevation",
            label: "Max Elevation",
            required: true,
          },
          {
            type: "Control",
            scope: "#/properties/elevationGain",
            label: "Elevation Gain",
            required: true,
          },
        ],
      },

      {
        type: "Control",
        scope: "#/properties/country",
        label: "Country",
        options: countries,
        required: true,
      },

      {
        type: "Control",
        scope: "#/properties/location",
        label: "Location",
        required: true,
      },

      {
        type: "HorizontalLayout",
        elements: [
          {
            type: "Control",
            scope: "#/properties/latitude",
            label: "Latitude",
            required: true,
          },

          {
            type: "Control",
            scope: "#/properties/longitude",
            label: "Longitude",
            required: true,
          },
        ],
      },
      {
        type: "Control",
        scope: "#/properties/description",
        label: "Description",
        required: true,
        options: {
          multiLine: true, // This option can be used to indicate a text area
        },
      },

      {
        type: "HorizontalLayout",
        elements: [
          {
            type: "Control",
            scope: "#/properties/isChildFriendly",
            label: "Is Child Friendly?",
          },

          {
            type: "Control",
            scope: "#/properties/isTraverse",
            label: "Is Traverse?",
          },
        ],
      },

      {
        type: "VerticalLayout",
        elements: [
          {
            type: "Control",
            scope: "#/properties/destinationIds",
            label: "Destination in the traverse",
            options: destinationOptions,
            format: "select",
            required: false,
            // rule: {
            //   effect: "SHOW",
            //   condition: {
            //     scope: "#/properties/isTraverse",
            //     value: true,
            //   },
            // },
          },
        ],
      },
    ],
  };
};

export const AddDestinationImageSchema = {
  type: "object",
  properties: {
    image: {
      type: "string",
      title: "Image",
      minLength: 3,
      description: "Please select an image",
      format: "data-url",
    },
    caption: {
      type: "string",
      title: "Image Caption",
      minLength: 3,
      description: "Please enter image capion",
    },
    isDisplayImage: {
      type: "boolean",
      title: "Is Display Image?",
    },
  },
};

export const AddDestinationImageUiShema = () => {
  return {
    type: "VerticalLayout",
    elements: [
      {
        type: "Control",
        scope: "#/properties/image",
        label: "Image",
        required: true,
        format: "data-url",
      },
      {
        type: "Control",
        scope: "#/properties/caption",
        label: "Image Caption",
        required: true,
      },

      {
        type: "Control",
        scope: "#/properties/isDisplayImage",
        label: "Is Display Image?",
      },
    ],
  };
};

export const AddAdventureSchema = {
  type: "object",
  properties: {
    destinationId: {
      type: "string",
      title: "Destination",
      enum: [
        { name: "Day Hike", id: "1" },
        { name: "Over Night", id: "2" },
        { name: "Mountaineering", id: "3" },
      ],
    },
    startDate: {
      type: "string",
      format: "datetime",
      title: "Start Date",
    },
    endDate: {
      type: "string",
      format: "datetime",
      title: "End Date",
    },

    itinerary: {
      type: "string",
      title: "Itinerary",
      description: "Itinerary",
    },
    whatToWear: {
      type: "string",
      title: "What to wear",
      description: "What to Wear",
    },
    whatToCarry: {
      type: "string",
      title: "What to Carry",
      description: "What to Carry",
    },

    priceGroups: {
      type: "array",
      name: "Price Group",
      items: {
        type: "object",
        properties: {
          group: {
            type: "string",
            enum: [
              "Citizens",
              "Residents",
              "Non-Residents",
              "Kenyan And East Africa Citizen",
              "Citizens And Residents",
            ],
          },
          amount: {
            type: "string",
            maxLength: 5,
          },
          currency: {
            type: "string",
            enum: [
              "GBP - British Pound Sterling",
              "BIF - Burundian Franc",
              "CAD - Canadian Dollar",
              "EUR - Euro",
              "KES - Kenyan Shiling",
              "RWF - Rwandan Franc",
              "ZAR - South African Rand",
              "TZS - Tanzanian Shilling",
              "UGX - Ugandan Shilling",
              "USD - United States Dollar",
            ],
          },
        },
      },
    },
    // paymentPlan: {
    //   type: "array",
    //   name: "Payment Plan",
    //   items: {
    //     type: "object",
    //     properties: {
    //       installment: {
    //         type: "string",
    //         enum: [
    //           "Booking Fee",
    //           "2nd Installment",
    //           "3rd Installment",
    //           "4th Installment",
    //           "5th Installment",
    //         ],
    //       },
    //       percentage: {
    //         type: "string",
    //         maxLength: 5,
    //       },
    //     },
    //   },
    // },
    bookingLink: {
      type: "string",
      title: "Booking Link",
      minLength: 3,
      description: "Please enter booking link",
    },
  },
};

export const AddAdventureUiSchema = (destinationOptions) => {
  return {
    type: "VerticalLayout",
    elements: [
      {
        type: "Control",
        scope: "#/properties/destinationId",
        label: "Destination",
        options: destinationOptions,
        required: true,
      },

      {
        type: "HorizontalLayout",
        elements: [
          {
            type: "Control",
            scope: "#/properties/startDate",
            label: "Start Date",
            required: true,
          },
          {
            type: "Control",
            scope: "#/properties/endDate",
            label: "End Date",
            required: true,
          },
        ],
      },

      {
        type: "Control",
        scope: "#/properties/itinerary",
        label: "Itinerary",
        required: true,
        options: {
          multiLine: true, // This option can be used to indicate a text area
        },
      },

      {
        type: "Control",
        scope: "#/properties/whatToWear",
        label: "What To Wear",
        required: true,
        options: {
          multiLine: true, // This option can be used to indicate a text area
        },
      },

      {
        type: "Control",
        scope: "#/properties/whatToCarry",
        label: "What To Carry",
        required: true,
        options: {
          multiLine: true, // This option can be used to indicate a text area
        },
      },

      {
        type: "VerticalLayout",
        elements: [
          {
            type: "Control",
            scope: "#/properties/priceGroups",
          },
        ],
      },

      // {
      //   type: "VerticalLayout",
      //   elements: [
      //     {
      //       type: "Control",
      //       scope: "#/properties/paymentPlan",
      //     },
      //   ],
      // },

      {
        type: "Control",
        scope: "#/properties/bookingLink",
        label: "Booking Link",
        required: true,
      },
    ],
  };
};

export const AddProgrammeSchema = {
  type: "object",
  properties: {
    name: {
      type: "string",
      title: "Name",
      minLength: 3,
      description: "Please enter destination name",
    },
    startDate: {
      type: "string",
      format: "datetime",
      title: "Start Date",
    },
    endDate: {
      type: "string",
      format: "datetime",
      title: "End Date",
    },
    description: {
      type: "string",
      title: "Description",
      description: "Description",
    },
    // adventureIds removed - now managed through separate adventure management interface
    duration: {
      type: "number",
      title: "Duration",
      description: "Please enter duration",
    },

    durationUnits: {
      type: "string",
      title: "Duration Type",
      enum: [
        { name: "Hours", id: "hours" },
        { name: "Days", id: "days" },
      ],
    },

    paymentPlan: {
      type: "array",
      name: "Payment Plan",
      title: "Payment Plan",
      items: {
        type: "object",
        properties: {
          installment: {
            type: "string",
            enum: [
              "Booking Fee",
              "2nd Installment",
              "3rd Installment",
              "4th Installment",
              "5th Installment",
            ],
          },
          percentage: {
            type: "string",
            maxLength: 5,
          },
        },
      },
    },
    bookingLink: {
      type: "string",
      title: "Booking Link",
      minLength: 3,
      description: "Please enter booking link",
    },
  },
};

export const AddProgrammePriceSchema = {
  type: "object",
  properties: {

    tieredPriceGroups: {
      type: "array",
      title: "Tiered Price Groups",
      name: "Tiered Price Groups",
      items: {
        type: "object",
        properties: {
          name: {
            type: "string",
            title: "Tier Name",
            enum: ["Tier 1", "Tier 2", "Tier 3", "Tier 4", "Tier 5"], // Predefined tier names
            description: "Select the name for this tier",
          },
          priceGroups: {
            type: "array",
            name: "Price Group for this Tier",
            items: {
              type: "object",
              properties: {
                group: {
                  type: "string",
                  enum: [
                    "Citizens",
                    "Residents",
                    "Non-Residents",
                    "Kenyan And East Africa Citizen",
                    "Citizens And Residents",
                  ],
                },
                amount: {
                  type: "string",
                  maxLength: 5,
                },
                currency: {
                  type: "string",
                  enum: [
                    "GBP - British Pound Sterling",
                    "BIF - Burundian Franc",
                    "CAD - Canadian Dollar",
                    "EUR - Euro",
                    "KES - Kenyan Shiling",
                    "RWF - Rwandan Franc",
                    "ZAR - South African Rand",
                    "TZS - Tanzanian Shilling",
                    "UGX - Ugandan Shilling",
                    "USD - United States Dollar",
                  ],
                },
              },
            },
          },
        },
      },
    },

  },
};

export const AddProgrammeDisplayImageSchema = {
  type: "object",
  properties: {
    displayImage: {
      type: "string",
      title: "Image",
      minLength: 3,
      description: "Please select a Display image",
      format: "data-url",
    },
  },
};

export const AddProgrammeUiSchema = (adventureOptions) => {
  return {
    type: "VerticalLayout",
    elements: [
      {
        type: "Control",
        scope: "#/properties/name",
        label: "Name",
        required: true,
      },
      {
        type: "HorizontalLayout",
        elements: [
          {
            type: "Control",
            scope: "#/properties/startDate",
            label: "Start Date",
            required: true,
          },
          {
            type: "Control",
            scope: "#/properties/endDate",
            label: "End Date",
            required: true,
          },
        ],
      },

      {
        type: "Control",
        scope: "#/properties/description",
        label: "Description",
        required: true,
        options: {
          multiLine: true, // This option can be used to indicate a text area
        },
      },
      // adventureIds UI control removed - now managed through separate adventure management interface
      {
        type: "HorizontalLayout",
        elements: [
          {
            type: "Control",
            scope: "#/properties/duration",
            label: "Duration",
            required: true,
          },

          {
            type: "Control",
            scope: "#/properties/durationUnits",
            label: "Duration Units",
            options: [
              { name: "Hours", id: "hours" },
              { name: "Days", id: "days" },
            ],
            required: true,
          },
        ],
      },

      {
        type: "VerticalLayout",
        elements: [
          {
            type: "Control",
            scope: "#/properties/paymentPlan",
          },
        ],
      },

      {
        type: "Control",
        scope: "#/properties/bookingLink",
        label: "Booking Link",
        required: true,
      },
    ],
  };
};


export const AddProgrammePriceUiSchema = () => {
  return {
    type: "VerticalLayout",
    elements: [
      {
        type: "Control",
        scope: "#/properties/tieredPriceGroups",
      },
    ]
    
  };
};

export const AddProgrammeDisplayImageUiSchema = () => {
  return {
    type: "VerticalLayout",
    elements: [
      
      {
        type: "Control",
        scope: "#/properties/displayImage",
        label: "Display Image",
        required: true,
        format: "data-url",
      },
    ],
  };
};

// Adventure Management Schema for Programme
export const ManageProgrammeAdventuresSchema = {
  type: "object",
  properties: {
    programmeId: {
      type: "string",
      title: "Programme ID",
      format: "hidden",
    },
    programmeName: {
      type: "string",
      title: "Programme Name",
      format: "hidden",
    },
    adventures: {
      type: "array",
      title: "Programme Adventures",
      format: "adventure-array",
      items: {
        type: "object",
        properties: {
          value: {
            type: "number",
            title: "Adventure ID",
          },
          name: {
            type: "string",
            title: "Adventure Name",
          },
          imageUrl: {
            type: "string",
            title: "Image URL",
          },
        },
      },
    },
    adventuresMarkedForDeletion: {
      type: "array",
      title: "Adventures Marked for Deletion",
      format: "hidden",
      items: {
        type: "number",
      },
    },
    adventuresToAdd: {
      type: "array",
      title: "Adventures to Add",
      format: "hidden",
      items: {
        type: "number",
      },
    },
  },
};

export const ManageProgrammeAdventuresUiSchema = (adventureOptions) => {
  return {
    type: "VerticalLayout",
    elements: [
      // Hidden fields - programmeId and programmeName are not displayed
      {
        type: "Control",
        scope: "#/properties/adventures",
        label: "Adventures in Programme",
        options: {
          newAdventureEnum: adventureOptions || [],
        },
      },
    ],
  };
};
